import { useHorizontalScroll } from '@/shared/lib/hooks/use-horizontal-scroll';
import { type ScrollAreaProps } from '@mantine/core';
import cs from 'clsx';
import { ForwardedRef } from 'react';

interface Props extends ScrollAreaProps {
  enabled?: boolean;
}

export const useScrollAreaMask = (props?: Props) => {
  const {
    enabled = true,
    scrollbars = 'y',
    ...rest
  } = props || {
    enabled: true,
    scrollbars: 'y',
  };
  const isVertical = scrollbars !== 'x';
  const ref = useHorizontalScroll<HTMLDivElement>(!isVertical);

  // const [innerBlockRef] = useResizeObserver();
  // const hasScroll = innerBlockRef
  //   ? innerBlockRef?.current?.scrollHeight >
  //     Math.round(ref.current?.getBoundingClientRect()?.height)
  //   : false;

  return {
    scrollbars,
    type: 'scroll',
    viewportRef: (e) => {
      ref.current = e;

      // if (e) {
      //   (innerBlockRef as MutableRefObject<HTMLDivElement>).current = e
      //     .children[0] as HTMLDivElement;
      // }
    },
    classNames: {
      viewport: cs(
        `transition transition-all duration-500  !mask-position-[center] !mask-repeat-[no-repeat]`,
        {
          'animate-[scroll-fade-x] animation-timeline-[scroll(x_self)]':
            !isVertical && enabled,

          'animate-[scroll-fade-y] animation-timeline-[scroll(y_self)]':
            isVertical && enabled,
        },
      ),
    },
    ...rest,
  } as ScrollAreaProps & {
    viewportRef: ForwardedRef<HTMLDivElement>;
  };
};